
  import { Vue, Component, Prop } from "vue-property-decorator";

  import ContractorAboutForManager from "@/components/contractors/ContractorAboutForManager.vue";
  import ContractorAboutForAdmin from "@/components/contractors/ContractorAboutForAdmin.vue";
  import LIST_MANAGERS from "@/apollo/managers/ListSingleManagers.gql";
  import { Company, User } from "@/generated/graphql";
  import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
  import Roles from "@/entities/Roles";

  @Component({
    components: {
      ContractorAboutForManager,
      LoadingOverlay,
      ContractorAboutForAdmin,
    },
    apollo:{
      managers: {
      query: LIST_MANAGERS,
      variables() {
        return this.managerArgs;
      },
      update(data) {
        this.hasAllResourceAccess = data.manager[0].resources_access_allowed;
        return data.manager.resources_access_allowed;
      },
    },
    }
  })
  export default class ContractorPublicPage extends Vue {
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: Object, required: true }) readonly company!: Company;
    @Prop({ type: String, required: true }) readonly id!: string;
    
    hasAllResourceAccess: boolean = false;

    get isAdmin(): boolean {
      return this.currentUser.role === Roles.ADMIN;
    }

     get managerArgs() {
    const filterConditions = [
      {
        user: {
          id: { _eq: this.currentUser.id },
        },
      },
    ];
    return {
      where: {
        _and: filterConditions,
      },
    };
  }

    get currentUserManagerId(): string {
      return this.currentUser.manager!.id
    }
  }
